import { render, staticRenderFns } from "./projectdetail.main.vue?vue&type=template&id=7a054e18"
import script from "./projectdetail.main.vue?vue&type=script&lang=ts"
export * from "./projectdetail.main.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports